import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";

export default function NotFoundPage() {
  return (
    <section className="bg-white py-32">
      <SEO title="Page Not Found" noindex />
      <div className="fg-container max-w-2xl text-center">
        <div className="text-xs font-bold uppercase tracking-[0.18em] text-blue-700">
          404
        </div>
        <h1 className="mt-4 font-display text-5xl font-extrabold tracking-tight text-slate-900 sm:text-6xl">
          Page not found.
        </h1>
        <p className="mt-5 text-base text-slate-600">
          The page you're looking for doesn't exist — but a plumber is just a call away.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-6 py-3 font-bold text-white hover:bg-slate-800"
          >
            Back home <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 rounded-lg border-2 border-slate-900 px-6 py-3 font-bold text-slate-900 hover:bg-slate-900 hover:text-white"
          >
            Contact us
          </Link>
        </div>
      </div>
    </section>
  );
}
